export default {
  id: "abcAnalysisByProduct",
  name: "",
  description: "",
  report: {
    name: "ABC Analysis by Product",
    chartType: "",
    template: "abc-analysis-by-product",
    config: {
      dataType: "single",
      dataSet: "InventoryAnalysis",
      measures: [
        "InventoryAnalysis.total_revenue",
        "InventoryItem.stock_retail",
        "InventoryItem.total_inventory",
      ],
      dimensions: [
        "Product.name",
        "Product.sku",
        "InventoryAnalysis.grade_string_revenue_subquery",
      ],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: false,
      limit: "100",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
      applyDateRangeFilter: false,
      filterDateRange: false,
    },
  },
};
